import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Avatar, Box, Typography } from '@material-ui/core';

export default function Header() {

  return (
    <AppBar position="relative">
      <Toolbar variant="dense">
        <div style={{ width: '100%', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box display="flex">
            <Box>
              <Avatar src="issets/img/pmpv_brasao.png" />
            </Box>
            <Box ml={1}>
              <Box>
                <Typography component="div" variant="body1"><Box fontSize={12}>Prefeitura do Município de</Box></Typography>
              </Box>
              <Box>
                <Typography component="div"><Box fontSize={16} fontWeight={600}>PORTO VELHO</Box></Typography>
              </Box>
            </Box>
          </Box>
          <Box fontWeight={600}>
            Agendamento online
          </Box>
        </div>
      </Toolbar>
    </AppBar>
  );
}
